module.exports = __webpack_public_path__ + "img/career_modal_setting_2.c821fb92.png";